import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=3a6d25a5&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=3a6d25a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d25a5",
  null
  
)

export default component.exports